export const state = {
  masters: [],
  incidents: [],
  liveAlert: true,
};

export const getters = {
  incidents: (state) => state.incidents,
  liveAlert: (state) => state.liveAlert,
  masters: (state) => state.masters
};

export const mutations = {
  updateIncidents (state, incidentsArray) {
    state.incidents = incidentsArray;
  },

  updateLiveAlert (state, alertStatus) {
    state.liveAlert = alertStatus;
  },

  setMasters (state, masters) {
    state.masters = masters;
  },
};

export const actions = {
  updateIncidents ({ commit }, incidentsArray) {
    commit("updateIncidents", incidentsArray);
  },

  updateLiveAlert ({ commit }, alertStatus) {
    commit("updateLiveAlert", alertStatus);
  },

  setMasters ({ commit }, masterData) {
    commit("setMasters", masterData);
  },
};
